<script>
import UsernameSelector from "../AccountSettings/UsernameSelector.vue";
import { GuardianshipService } from "../../services/GuardianshipService"

export default {
  name: "NewGuardianForm",
  components: {UsernameSelector},
  props: {
    wards: {
      type: Array,
      required: true,
    },
    enablePhoneLogin: {
      type: Boolean,
      required: false,
      default: false
    },
  },
  data() {
    return {
      guardian: {
        given_name: "",
        family_name: "",
        login: "",
        login_confirm: "",
        login_type: "email",
      },
      show_invalid: false,
      guardianship_id: null,
    }
  },
  computed: {
    guardian_payload() {
      const payload = {
        given_name: this.guardian.given_name,
        family_name: this.guardian.family_name,
        email: null,
        phone_number: null,
      }

      if (this.guardian.login_type === 'phone') {
        payload.phone_number = this.guardian.login
      } else if (this.guardian.login_type === 'email') {
        payload.email = this.guardian.login
      }
      return payload
    },
    valid_given_name() {
      return this.guardian.given_name?.trim().length > 0
    },

    valid_family_name() {
      return this.guardian.family_name?.trim().length > 0
    },
    shouldShowUsernameTypes() {
      return this.enablePhoneLogin
    },
    showUsernameConfirmationField() {
      return this.guardian.login_type === "email"
    },
    hasErrors() {
      return !this.valid_given_name || !this.valid_family_name;
    },
    usernameTitle(){
      if (this.shouldShowUsernameTypes) {
        return ''
      }
      return this.$t('signUp.signUpWith')
    },

  },
  methods: {
    onLoginTypeChanged(type) {
      this.guardian.login_type = type;
      this.guardian.login = "";
    },
    onLoginConfirmChanged(confirm) {
      this.guardian.login_confirm = confirm;
    },
    async submitForm() {
      try {
        const guardianToCreate = this.guardian_payload
        const response = await GuardianshipService.save(guardianToCreate, this.wards)
        this.$emit('guardian-created', response.data)
      } catch (error) {
        const errors = JSON.parse(error.response.request.response).errors
        if (error.response) {
          let error_text = this.$t("signUp.errors.invalidField")
          if (errors.given_name?.includes("is invalid")) {
            error_text = this.$t("signUp.errors.givenNameBlank")
          } else if (errors.email?.includes("is invalid")) {
            error_text = this.$t("signUp.errors.emailInvalid")
          } else if (errors.email?.includes("can't be blank")) {
            error_text = this.$t("signUp.errors.emailBlank")
          } else if (errors.phone_number?.includes("is invalid")) {
            error_text = this.$t("signUp.errors.phoneInvalid")
          } else if (errors.phone_number?.includes("can't be blank")) {
            error_text = this.$t("signUp.errors.phoneBlank")
          } else if (errors.base?.length) {
            error_text = errors.base.join(", ")
          }

          this.$notify({
            group: "default",
            type: "error",
            duration: 5000,
            text: error_text
          });
        }
      }
    },
  },
}
</script>

<template>
  <div class="new-guardian-form">
    <div class="text-left">
      <a-text as="h6">{{ $t("signUp.firstName") }}</a-text>
      <a-form-input
          id="guardian-given-name"
          label=""
          v-model="guardian.given_name"
          :show-error="!valid_given_name"
          :error-message="$t('signUp.errors.firstNameBlank')"
      />
    </div>

    <div class="text-left">
      <a-text as="h6">{{ $t("signUp.lastName") }}</a-text>
      <a-form-input
          id="guardian-last-name"
          label=""
          v-model="guardian.family_name"
          :show-error="!valid_family_name"
          :error-message="$t('signUp.errors.familyNameBlank')"
      />
    </div>

    <div class="text-left">
      <username-selector
          ref="usernameSelector"
          v-model="guardian.login"
          :type="guardian.login_type"
          :show-tabs="shouldShowUsernameTypes"
          :confirm="showUsernameConfirmationField"
          :title="usernameTitle"
          @type-changed="onLoginTypeChanged"
          @confirm-input="onLoginConfirmChanged"
      ></username-selector>
    </div>

    <a-button
        variant="secondary"
        class="next-button"
        :disabled="hasErrors"
        @click="submitForm"
    >{{ $t("signUp.next") }}</a-button>
  </div>
</template>

<style scoped lang="scss">
.next-button {
  margin-top: 16px;
  border-radius: 8px;
  height: 48px;
  width: 100%;
  display: flex;
  justify-content: center;
}
</style>
